// Environment configuration for the frontend application

import { API_URL } from "@/config";

// Environment-specific fallbacks
const getEnvironmentConfig = () => {
  const mode = import.meta.env.MODE;

  // Define fallback URLs for each environment
  const fallbacks = {
    localhost: {
      API_URL: "http://localhost:5050/api",
 
      BACKEND_URL: "http://localhost:5050",
      WS_URL: "ws://localhost:5050",
    },
    dev: {
      API_URL: "https://dev-api.infinity.mawsoftwares.in/api",
      BACKEND_URL: "https://dev-api.infinity.mawsoftwares.in",
      WS_URL: "wss://dev-api.infinity.mawsoftwares.in",
    },
    staging: {
      API_URL: "https://api.infinity.mawsoftwares.in/api",
      BACKEND_URL: "http://api.infinity.mawsoftwares.in",
      WS_URL: "wss://api.infinity.mawsoftwares.in",
    },
    jalgoan: {
      API_URL: "https://api.jalgoan.infinity.mawsoftwares.in/api",
      BACKEND_URL: "https://jalgoan-api.infinity.mawsoftwares.in",
      WS_URL: "wss://jalgoan-api.infinity.mawsoftwares.in",
    },
    production: {
      API_URL: "https://api.infinity.mawsoftwares.in/api",
      BACKEND_URL: "https://api.infinity.mawsoftwares.in",
      WS_URL: "wss://api.infinity.mawsoftwares.in",
    },
  };

  return fallbacks[mode as keyof typeof fallbacks] || fallbacks.localhost;
};

const envFallbacks = getEnvironmentConfig();

// Debug logging
console.log('Environment Debug:');
console.log('Current mode:', import.meta.env.MODE);
console.log('VITE_API_URL:', import.meta.env.VITE_API_URL);
console.log('envFallbacks.API_URL:', envFallbacks.API_URL);

export const config = {
  // API Configuration with environment-specific fallbacks
   API_URL: import.meta.env.VITE_API_URL || envFallbacks.API_URL,
  // API_URL: "http://192.168.1.36:5050/api",
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL || envFallbacks.BACKEND_URL,
  WS_URL: import.meta.env.VITE_WS_URL || envFallbacks.WS_URL,

  // Authentication Configuration
  USE_COOKIES: import.meta.env.VITE_USE_COOKIES === "true" || true,

  // Environment
  NODE_ENV: import.meta.env.MODE || "development",
  IS_DEVELOPMENT: import.meta.env.MODE === "development",
  IS_STAGING: import.meta.env.MODE === "staging",
  IS_JALGOAN: import.meta.env.MODE === "jalgoan",
  IS_PRODUCTION: import.meta.env.MODE === "production",
  IS_LOCALHOST: import.meta.env.MODE === "localhost",

  // Environment validation
  CURRENT_ENVIRONMENT: import.meta.env.MODE,

  // Feature Flags
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === "true" || false,
  ENABLE_DEBUG_MODE: import.meta.env.VITE_ENABLE_DEBUG_MODE === "true" || true,
  ENABLE_HOT_RELOAD: import.meta.env.VITE_ENABLE_HOT_RELOAD === "true" || false,
  ENABLE_SOURCE_MAPS:
    import.meta.env.VITE_ENABLE_SOURCE_MAPS === "true" || false,
  ENABLE_COMPRESSION:
    import.meta.env.VITE_ENABLE_COMPRESSION === "true" || false,
  ENABLE_CACHE: import.meta.env.VITE_ENABLE_CACHE === "true" || false,

  // App Configuration
  APP_NAME: import.meta.env.VITE_APP_NAME || "Infinity Orders",
  APP_VERSION: import.meta.env.VITE_APP_VERSION || "1.0.0",
  
  // Branch Configuration
  BRANCH_NAME: import.meta.env.VITE_BRANCH_NAME || "Production Workflow",
  
  // PWA Configuration
  PWA_NAME: import.meta.env.VITE_PWA_NAME || "Infinity Worriers",
  PWA_SHORT_NAME: import.meta.env.VITE_PWA_SHORT_NAME || "Worriers",

  // Logging
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || "info",

  // External Services
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || "",
  GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || "",

  // Default settings
  DEFAULT_PAGE_SIZE: 10,
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB

  // Timeouts
  REQUEST_TIMEOUT: 60000, // 60 seconds - increased for complex operations
  TOKEN_REFRESH_THRESHOLD: 5 * 60 * 1000, // 5 minutes
};

// Utility function to log environment configuration (useful for debugging)
export const logEnvironmentConfig = () => {
  if (config.ENABLE_DEBUG_MODE) {
    console.group("🔧 Environment Configuration");
    console.log("Environment:", config.CURRENT_ENVIRONMENT);
    console.log("API URL:", config.API_URL);
    console.log("Backend URL:", config.BACKEND_URL);
    console.log("WebSocket URL:", config.WS_URL);
    console.log("App Name:", config.APP_NAME);
    console.log("App Version:", config.APP_VERSION);
    console.log("PWA Name:", config.PWA_NAME);
    console.log("PWA Short Name:", config.PWA_SHORT_NAME);
    console.log("Debug Mode:", config.ENABLE_DEBUG_MODE);
    console.log("Analytics:", config.ENABLE_ANALYTICS);
    console.groupEnd();
  }
};

// Validate required environment variables
export const validateEnvironment = () => {
  const requiredVars = ["API_URL", "BACKEND_URL"];
  const missing = requiredVars.filter(
    (varName) => !config[varName as keyof typeof config]
  );

  if (missing.length > 0) {
    console.error("❌ Missing required environment variables:", missing);
    return false;
  }

  return true;
};

export default config;
